import { render, staticRenderFns } from "./LayerLegendImage.vue?vue&type=template&id=33297ff9&"
import script from "./LayerLegendImage.vue?vue&type=script&lang=js&"
export * from "./LayerLegendImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports